import { useCallback, useState } from "react";

export function useTabs(options: string[]) {
  const [activeTab, setActiveTab] = useState(options[0]);
  const handleSelect = useCallback((value: string) => {
    setActiveTab(value);
  }, []);
  return { activeTab, handleSelect };
}
